const learnMoreDropdownItems = [
  {
    link: '',
    name: 'Learn More',
    path: '',
    subItems: [
        {
          name: 'Lucidworks',
          externalLink: 'https://lucidworks.com/'
        },
        {
          name: 'Knowledge Base',
          externalLink: 'https://support.lucidworks.com/'
        },
        {
          name: 'Blog',
          externalLink: 'https://lucidworks.com/blog/'
        },
        {
          name: 'Webinars',
          externalLink: 'https://lucidworks.com/videos/?fwp_video_category=webinar'
        },
        {
          name: 'Ebooks',
          externalLink: 'https://lucidworks.com/ebooks/'
        },
        {
          name: 'Training',
          externalLink: 'https://academy.lucidworks.com/'
        },
        {
          name: 'Support',
          externalLink: 'https://support.lucidworks.com/'
        },
    ]
  }
]

export default learnMoreDropdownItems;
